/**
 * Query params mirrored on platform GraphQL requests so resolvers align with checkout URL
 * identity (Zendesk/agent `lead_token`, shareable flows, visitor overrides).
 *
 * Keep in sync with `draft_session_identity.ts` / platform `LandingApi::GraphqlController`.
 */
const CHECKOUT_GRAPHQL_IDENTITY_PARAMS = [
  'lead_token',
  'proxy_token',
  'wvt',
  'customer_token',
] as const;

/** Returns serialized query substring (no leading '?') */
export function getCheckoutGraphqlIdentityQueryRaw(): string {
  if (typeof window === 'undefined') {
    return '';
  }
  const src = new URLSearchParams(window.location.search);
  const out = new URLSearchParams();

  for (const key of CHECKOUT_GRAPHQL_IDENTITY_PARAMS) {
    const val = src.get(key);
    if (val != null && val !== '') {
      out.set(key, val);
    }
  }

  return out.toString();
}
